import type { Action } from "@wayflyer/flyui";
import { ButtonGroup, Flex, Image, NumberedMilestones, Subheading } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

import { SHOPIFY_MESSAGES } from "./message-definitions";

interface ShopifyInitialConnectionProps {
  fullWidthImage?: boolean;
  connectHandler: () => Promise<void>;
}

export const ShopifyInitialConnection = ({ connectHandler, fullWidthImage = false }: ShopifyInitialConnectionProps) => {
  const intl = useIntl();

  const milestones = [
    {
      number: "01",
      title: intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectStepOneTitle),
      body: intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectStepOneDescription),
    },
    {
      number: "02",
      title: intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectStepTwoTitle),
      body: intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectStepTwoDescription),
    },
    {
      number: "03",
      title: intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectStepThreeTitle),
      body: intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectStepThreeDescription),
    },
  ];

  const primaryAction: Action = {
    analyticsId: "connect-intial-shopify-store",
    content: intl.formatMessage(MESSAGES.connectStoreLabel),
    onAction: connectHandler,
  };

  return (
    <Flex direction="column" gap="5">
      <Flex direction="column" gap="4">
        <Subheading>{intl.formatMessage(SHOPIFY_MESSAGES.shopifyConnectSubHeading)}</Subheading>
        <NumberedMilestones milestones={milestones} />
        <ButtonGroup primaryAction={primaryAction} />
      </Flex>
      {fullWidthImage ? (
        <Image
          src="https://cdn.sanity.io/images/1aendizt/production/eeafe8f65d5634e4bc10c557278caa97d903c950-1448x724.jpg?auto=format"
          alt="Screenshot of the Shopify App Store page featuring the Wayflyer app"
          width="100%"
        />
      ) : (
        <Image
          src="https://cdn.sanity.io/images/1aendizt/production/eeafe8f65d5634e4bc10c557278caa97d903c950-1448x724.jpg?auto=format"
          alt="Screenshot of the Shopify App Store page featuring the Wayflyer app"
          className="gridContentConstrainedWidth"
        />
      )}
    </Flex>
  );
};
